"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./MediaQueryContainer.css");
var debounce = require("lodash.debounce");
var MediaQueryContainer = (function (_super) {
    __extends(MediaQueryContainer, _super);
    function MediaQueryContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.isVisibleLookup = {};
        _this._getSizeOfMedia = _this._getSizeOfMedia.bind(_this);
        _this._resized = _this._resized.bind(_this);
        _this._setIsVisibleLookup = _this._setIsVisibleLookup.bind(_this);
        _this._setIsVisibleLookup();
        _this.state = { mediaSize: _this._getSizeOfMedia() };
        return _this;
    }
    MediaQueryContainer.prototype.componentDidMount = function () {
        var debounced = debounce(this._resized, 200);
        window.addEventListener("resize", debounced);
    };
    MediaQueryContainer.prototype._resized = function () {
        var size = this._getSizeOfMedia();
        this.setState({ mediaSize: size });
    };
    MediaQueryContainer.prototype._setIsVisibleLookup = function () {
        this.isVisibleLookup = {
            'Min': this.props.isVisible,
            'Xs': this.props.isVisibleForXs,
            'Sm': this.props.isVisibleForSm,
            'Md': this.props.isVisibleForMd,
            'Lg': this.props.isVisibleForLg,
            'Xl': this.props.isVisibleForXl
        };
        var previousIsVisible = this.isVisibleLookup['Min'];
        for (var size in this.isVisibleLookup) {
            if (this.isVisibleLookup[size] === null) {
                this.isVisibleLookup[size] = previousIsVisible;
            }
            else {
                previousIsVisible = this.isVisibleLookup[size];
            }
        }
    };
    MediaQueryContainer.prototype._getSizeOfMedia = function () {
        var mediaBreakpoints = {
            'Xl': this.props.breakpointXl,
            'Lg': this.props.breakpointLg,
            'Md': this.props.breakpointMd,
            'Sm': this.props.breakpointSm,
            'Xs': this.props.breakpointXs
        };
        var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        for (var size in mediaBreakpoints) {
            if (width > mediaBreakpoints[size]) {
                return size;
            }
        }
        return 'Min';
    };
    MediaQueryContainer.prototype.render = function () {
        var content = this.isVisibleLookup[this.state.mediaSize] &&
            React.createElement("div", { className: "p-mediaquerycontainer", "data-tag": this.props.tag }, this.props.children);
        return content;
    };
    return MediaQueryContainer;
}(React.Component));
MediaQueryContainer.defaultProps = {
    tag: null,
    isVisible: true,
    isVisibleForXs: null,
    isVisibleForSm: null,
    isVisibleForMd: null,
    isVisibleForLg: null,
    isVisibleForXl: null,
    breakpointXs: 480,
    breakpointSm: 600,
    breakpointMd: 840,
    breakpointLg: 960,
    breakpointXl: 1280
};
exports.MediaQueryContainer = MediaQueryContainer;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['layout-controls'])
        csod.engine.controls['layout-controls'] = {};
    csod.engine.controls['layout-controls']['MediaQueryContainer'] = MediaQueryContainer;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["MediaQueryContainer"] = [];


//////////////////
// WEBPACK FOOTER
// ../player-layout-controls/controls/MediaQueryContainer/index.js
// module id = 26
// module chunks = 0